import { config } from '@fortawesome/fontawesome-svg-core';
import { useEffect, useRef, useState } from 'react';

import Checkers from '../../../../../../helpers/class/Checkers';

import '@fortawesome/fontawesome-svg-core/styles.css';

config.autoAddCss = false;

import { useInViewport } from 'react-in-viewport';
import { useSelector } from 'react-redux';


export default function B2BDescViewPort(props) {
    const [isPublicDomain, setIsPublicDomain] = useState(useSelector(state => state['appSettings']['isPublicDomain']))
    const [publicDomain, setPublicDomain] = useState(0);

    useEffect(() => {
        setPublicDomain(isPublicDomain)
    }, [isPublicDomain, setPublicDomain])

    const config = { disconnectOnLeave: false };
    const options = {};
    const myRef = useRef();
    const {
        inViewport
    } = useInViewport(
        myRef,
        options,
        config,
        props
    );

    const b2description = props.details.b2b_description

    const isHtmlEmpty = (html) => {
        if (!html) return true

        const text = html.replace(/<[^>]*>/g, '').trim()
        return text === ''
    }

    const isPasswordProtectionEnabled = Checkers.valueToBoolean(props.passwordEnabled)

    let viewPortResult = null;
    viewPortResult =
        <>
            {
                publicDomain != 1 ?
                    <>
                        {isPasswordProtectionEnabled && !isHtmlEmpty(b2description) ? <div dangerouslySetInnerHTML={{ __html: b2description }} /> : <></>}
                    </>
                    :
                    <>
                    </>

            }
        </>
        ;

    return (
        <>
            {publicDomain != 1 &&
                <div ref={myRef} id="pro_detail_b2b_desc" className="row full-width no-margin py-4">
                    {viewPortResult}
                </div>
            }
        </>
    )
}
